export class FailureModal {
  private scene: Phaser.Scene;
  private displayObjects: any[];
  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.displayObjects = [];
    const gfx = scene.add.graphics({
      fillStyle: {
        color: 0x000000,
        alpha: 0.7,
      },
    });

    gfx.fillRoundedRect(64 - 32, 64 - 22, 16 * 4, 16 * 3, 2);
    gfx.setDepth(45);
    const text = scene.add.text(
      64,
      64,
      `Lost\nZ - undo\nR - restart\nESC - map`,
      {
        fontFamily: "sins",
        fontSize: "16px",
        align: "center",
      }
    );

    text.setResolution(10);
    text.setOrigin(0.5);
    text.setDepth(50);
    this.displayObjects.push(text);
    this.displayObjects.push(gfx);
  }

  setVisible(v: boolean) {
    this.displayObjects.forEach((d) => d.setVisible(v));
  }
}
